<template>
  <div class="home">
    <div class="placeholder">
      Portfolio is not selected!
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    if (route.query.uuid !== undefined) {
      const { uuid } = route.query;
      const uuidShort = [...uuid].slice(0, 8).join('') || '';

      if (uuidShort.length === 8) {
        router.push({ path: `/${uuidShort}` });
      }
    }
  },
};
</script>

<style scoped>
.placeholder {
  padding-top: 50px;

  color: var(--text-color);
  font-size: 20px;
  text-align: center;
}
</style>
